import { Box, styled } from '@mui/material';
import { LwFormMultiSelect, LwFormSelect } from 'redesign';
import { useFormContext, useWatch } from 'react-hook-form';
import { AndBlockProps, FormValues } from './enroll-node.types';
import { BlockHeader } from './block-header';

const conditionOptions = [{ label: 'Is equal to', value: 'equal' }];

export const AndBlock = ({
  entityTypeOptions,
  entityOptions,
  usedEntityTypes,
  andIndex,
  orIndex,
  canRemove,
  onRemove,
}: AndBlockProps) => {
  const { control, setValue } = useFormContext<FormValues>();

  const selectedType = useWatch({
    control,
    name: `orBlocks.${orIndex}.andBlocks.${andIndex}.entityType`,
  });

  const filteredTypeOptions = entityTypeOptions.filter(
    (option) => !usedEntityTypes.includes(option.value) || option.value === selectedType
  );

  const currentEntityOptions = selectedType ? entityOptions[selectedType] : [];

  return (
    <AndBlockWrapper>
      <BlockHeader
        title={`AND condition #${andIndex + 1}`}
        onRemove={onRemove}
        canRemove={canRemove}
      />
      <LwFormSelect
        name={`orBlocks.${orIndex}.andBlocks.${andIndex}.entityType`}
        label="Entity type"
        control={control}
        options={filteredTypeOptions}
        rules={{ required: true }}
        defaultLabel="Select entity type"
        onChange={() => {
          setValue(`orBlocks.${orIndex}.andBlocks.${andIndex}.entityId`, []);
        }}
      />
      <LwFormSelect
        name={`orBlocks.${orIndex}.andBlocks.${andIndex}.condition`}
        label="Condition"
        control={control}
        disabled={true}
        rules={{ required: true }}
        options={conditionOptions}
      />
      <LwFormMultiSelect
        name={`orBlocks.${orIndex}.andBlocks.${andIndex}.entityId`}
        label="Entity"
        control={control}
        options={currentEntityOptions}
        rules={{ required: true }}
        disabled={!selectedType}
        getOptionLabel={(option) => option.label}
        getOptionKey={(option) => option.value}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        enableSelectAll={true}
      />
    </AndBlockWrapper>
  );
};

const AndBlockWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.lwPrimaryAccentLight[100]}`,
  borderRadius: 12,
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
  flexShrink: 0,
}));
